module.exports = __webpack_public_path__ + "static/media/music-button.404145ac.png";